export default (app) => {
  app.database.on("initMemory", ({ collection, db, inited }) => {
    if (inited) return;
    db.updates = (query) => {
      if (collection.contentType.staticContent) return { ...query, ids: [] };
      let ids = [];
      const { dbArray } = db;
      let i = dbArray.length - 1;
      if (i === -1 || !dbArray[i]._chdate || !query.date) return;
      while (i !== -1 && dbArray[i]._chdate > query.date) {
        ids.push(dbArray[i]._id);
        i--;
      }
      if (ids.length > 100) ids = undefined;
      return { ...query, ids };
    };
  });
};
